

export * from './panelPadding';

export const PLAYER_CONTROLS_HEIGHT = 100;
export const CLIP_MODE_ALERT_HEIGHT = 52;
export const VIDEO_PLAYER_ID = 'video-player';
export const ACCEPTABLE_GRID_SIZES = [1, 2, 4, 8];
export const NUMBER_OF_VALUES = 60;

// WebRTC metrics collection.
// At 1 sample/sec (see usePlayer STATS_SAMPLE_INTERVAL_MS), these mean:
//   - WEBRTC_POINT_EVERY_SAMPLES: one point per metric this often (~5s): gauges averaged, counters as a delta.
//   - WEBRTC_FLUSH_EVERY_SAMPLES: send the buffered points to analytics this often (~60s).
export const WEBRTC_POINT_EVERY_SAMPLES = 5;
export const WEBRTC_FLUSH_EVERY_SAMPLES = 60;
export const DEFAULT_ZOOM = 35;
export const ZOOM_FACTOR = 0.5;
export const DRAWER_WIDTH = 450;
export const AUTOISO_PANEL_MIN_HEIGHT = 226;
export const AUTOISO_PANEL_MAX_HEIGHT = 600;
